module.exports = __webpack_public_path__ + "static/media/1017027.b158dc38.jpg";